import { isStaticRender } from 'helpers/ContentHelper';
import { isTestEnvironment } from 'helpers/TestHelper';
import { removeCookie, setCookie } from './Helper';

/*  without conditionally requiring the package we will
    encounter Blob errors from static builds and tests */
const canAutoplayLibrary =
  !isStaticRender() && !isTestEnvironment() ? require('can-autoplay').default : null;

export const SET_CAN_I_AUTOPLAY_RESULT = 'SET_CAN_I_AUTOPLAY_RESULT';

const getCanIAutoplay = async () => {
  const enabled = canAutoplayLibrary;
  removeCookie();
  if (enabled) {
    const response = await canAutoplayLibrary.video({ timeout: 5000, inline: true, muted: true });
    const { result: isAutoplaySupported, error } = response;
    if (error) console.error(error);
    setCookie(isAutoplaySupported);
    return isAutoplaySupported;
  }
  return null;
};
export const setResult = async () => {
  const payload = await getCanIAutoplay();
  return {
    type: SET_CAN_I_AUTOPLAY_RESULT,
    payload,
  };
};
